import classNames from "classnames/bind"
import styles from "./ModalInfoFace.module.css"
import { Col, Image, Modal, Row } from "antd";
import { getTimeFormArray } from "../../../../../utils";
const cx = classNames.bind(styles);

function ModalInfoFace({ open, onCancel, info }) {
    return (
        <Modal
            title="Thông tin chi tiết"
            open={open}
            onOk={onCancel}
            onCancel={onCancel}
            footer={null}
            classNames={cx("custom-modal")}
            width={"50%"}
            centered
        >
            <Row gutter={[16, 16]} justify={'center'} wrap>
                <Col xs={24} lg={12}>
                    <Image src={process.env.REACT_APP_FSR_EVENT + info?.image} className={cx('image')} />
                </Col>
                <Col xs={24} lg={12}>
                    <div className={cx("info-object")}>
                        <div className={cx("row-info")}>
                            <label className={cx("label-info")}>Tên đối tượng:</label>
                            <div className={cx("content-info")}>{info?.staffName}</div>
                        </div>
                        <div className={cx("row-info")}>
                            <label className={cx("label-info")}>Phòng ban:</label>
                            <div className={cx("content-info")}>{info?.departmentName}</div>
                        </div>
                        <div className={cx("row-info")}>
                            <label className={cx("label-info")}>Đơn vị:</label>
                            <div className={cx("content-info")}>{info?.organizationName}</div>
                        </div>
                        <div className={cx("row-info")}>
                            <label className={cx("label-info")}>Thời gian:</label>
                            <div className={cx("content-info")}>{info?.time ? getTimeFormArray(info?.time) : ''}</div>
                        </div>
                    </div>
                </Col>
            </Row>
        </Modal>
    )
}

export default ModalInfoFace;